module.exports = __webpack_public_path__ + "img/retail.5fc06be4.png";